import React, { useContext } from 'react'
import { DefectContext } from './SingleDefect'
import TextField from '@mui/material/TextField'

const Description = () => {
  const { defect, setDefect, setChangesPresent } = useContext(DefectContext)
  return (
    <TextField
      value={defect.description || ''}
      onChange={(e) => {
        setChangesPresent(true)
        setDefect((prev) => ({
          ...prev,
          description: e.target.value,
        }))
      }}
      multiline
      minRows={6}
      label="Description"
      size="small"
      placeholder="Describe the issue, its impact and any immediate action taken…"
    />
  )
}

export default Description
